import * as ReactService from "@intech/react-service";
import { SaldoContribuicoesFaelceEntidade } from "../entidades/SaldoContribuicoesFaelceEntidade";
import { FichaFinanceiraEntidade } from "../entidades/FichaFinanceiraEntidade";
import { Faelce_ExtratoCDEntidade } from "../entidades/Faelce_ExtratoCDEntidade";

class FichaFinanceira extends ReactService.BaseService {
  constructor() {
    super("FichaFinanceira");
  }

  BuscarSaldoContribuicoesPorReferencia = (cdPlano: string, ano: string, mes: string) =>
    this.CreateRequest<SaldoContribuicoesFaelceEntidade>(ReactService.RequestType.GET, `BuscarSaldoContribuicoesPorReferencia/${cdPlano}/${ano}/${mes}`);

  BuscarDetalhamento = (cdPlano: string, periodo: number, ano: string, mes: string) =>
    this.CreateRequest<FichaFinanceiraEntidade[]>(ReactService.RequestType.GET, `BuscarDetalhamento/${cdPlano}/${periodo}/${ano}/${mes}`);

  GerarRelatorioExtratoBD = (cdPlano: string, periodo: number, ano: string, mes: string, enviarPorEmail: boolean) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `GerarRelatorioExtratoBD/${cdPlano}/${periodo}/${ano}/${mes}/${enviarPorEmail}`, null, ReactService.ResponseType.Blob);

  BuscarSRCCD = (cdPlano: string) =>
    this.CreateRequest<FichaFinanceiraEntidade[]>(ReactService.RequestType.GET, `BuscarSRCCD/${cdPlano}`);

  BuscarContribuicaoPorPeriodoReferencia = (cdPlano: string, periodo: number, ano: string, mes: string) =>
    this.CreateRequest<Faelce_ExtratoCDEntidade[]>(ReactService.RequestType.GET, `BuscarContribuicaoPorPeriodoReferencia/${cdPlano}/${periodo}/${ano}/${mes}`);

  BuscarSaldoContribuicoes = (cdPlano: string) =>
    this.CreateRequest<SaldoContribuicoesFaelceEntidade>(ReactService.RequestType.GET, `BuscarSaldoContribuicoes/${cdPlano}`);

  GerarRelatorioExtratoCD = (cdPlano: string, periodo: number, ano: string, mes: string, enviarPorEmail: boolean) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `GerarRelatorioExtratoCD/${cdPlano}/${periodo}/${ano}/${mes}/${enviarPorEmail}`, null, ReactService.ResponseType.Blob);

  BuscarContribuicao = (cdPlano: string) =>
    this.CreateRequest<FichaFinanceiraEntidade[]>(ReactService.RequestType.GET, `BuscarContribuicao/${cdPlano}`);

}

export const FichaFinanceiraService = new FichaFinanceira();
